<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card title="Autenticazione necessaria" subtitle="Immetti le tue credenziali per accedere al sistema"
            class="pa-2" flat>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="username" :counter="10" :label="t('Username')" required autocomplete="username"
                @keypress.enter="login"></v-text-field>
            <v-text-field v-model="password" label="Password" required autocomplete="current-password"
                :append-icon="!showPwd ? 'mdi-eye' : 'mdi-eye-off'" :type="showPwd ? 'text' : 'password'"
                @click:append="showPwd = !showPwd" @keypress.enter="login"></v-text-field>
            <p class="text-center my-3 font-weight-bold">
              <span v-if="showMessage">
                {{ message }}
              </span>
              <span v-else>
                &nbsp
              </span>
            </p>
            <v-card-actions class="justify-center">
              <v-btn color="blue-darken-3" class="px-3" @click="login" variant="flat" :disabled="showMessage">
                Accedi
              </v-btn>

              <v-btn v-if="ENVIRONMENT === 'development'" color="warning" class="mr-4" @click="fakeLogin"
                  variant="flat">
                Fake
              </v-btn>
              <!-- <v-btn v-if="ENVIRONMENT == 'development'" color="success" class="mr-4" @click="upcheck"
                  variant="flat" >
                upcheck
              </v-btn> -->
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>

import { useI18n } from "vue-i18n"

import { useRuntimeStore } from "@/store/runtime"

import router from "@/router"
import { ref, computed, onMounted } from "vue"

import { useToastsStore } from "@/store/toasts"

import { useDevice } from "@/service/device"
import { useApi } from "@/service/api"
const api = useApi()


const device = useDevice()
const deviceId = device.id   // is not "unique"

const toastsStore = useToastsStore()



const runtimeStore = useRuntimeStore()
const { t } = useI18n({})

const username = ref("")
const password = ref("")

const message = ref(null)

const showMessage = computed(() => {
  return message.value != null
})

const showPwd = ref(false)



let login_endpoint = ''

async function upcheck() {
  const result = await api.tracker.upcheck()
}

const stagingAuthorizedUsers = []
const productionAuthorizedUsers = ["marco", "mainetti_a", "peracino_a", "bracotto_g",]



async function fakeLogin() {


  const userFakeData = { "username": "marco", "is_superuser": true, "token": "8ff500cf5544b28dca8156230f4b5484c7f7a565", "last_name": "", "is_staff": true, "groups": ["ufficio_botanico", "comunicatore_dati", "segnalatore"], "pk": 63, "is_active": true, "first_name": "Marco M.", "email": "marco.milone@gmail.com"  } 
  runtimeStore.saveUserData(userFakeData)
  
  // toastsStore.toast({
  //   title: 'Autenticazione FAKE',
  //   text: 'Autenticazione FAKE effettuata con successo',
  //   type: 'success',
  //   callbackOnHide: () => {
  //     window.location.reload()
  //     router.push({ name: 'root' }, () => {
  //     })
  //   }
  // })

}
async function login() {

  message.value = "tentativo di accesso..."


  const result = await api.tracker.login({
    username: username.value,
    password: password.value,
    device: deviceId,
  })

  console.log("👨", result)

  setTimeout(() => {
    message.value = null
  }, 3000)

  if (!result?.data?.success) {
    message.value = "accesso non riuscito"
    return
  }
  if (!result.data.user?.is_active) {
    message.value = "utente non attivo"
    return
  }

  message.value = "accesso effettuato"

  runtimeStore.saveUserData(result.data.user)

  toastsStore.toast({
    title: 'Autenticazione',
    text: 'Autenticazione effettuata con successo',
    type: 'success',
    callbackOnHide: () => {
      window.location.reload()
      router.push({ name: 'root' }, () => {
      })
    }
  })




}


onMounted(() => {
  if (runtimeStore.session.user) {
    router.push({ name: 'root' })
    // router.push("/")

  }
  else {
    console.log("👮‍♂️ user not found in session - login needed", login_endpoint)
  }



})

</script>
